import { RecoCardProduct } from 'types/outfitRecos';

export const generateOutfitGroup = (groupId: string, productList: RecoCardProduct[]) => ({
  groupId,
  styleIds: productList.map(product => product.styleId)
});
